import { BASE_PATH_API } from '@manager-base/app-base/environment/paths/constants';
import { createActions } from '@manager-base/app-base/config/data-access';

const actions = {
    getUnclearedTransactions: {
        method: 'GET',
        url: `${BASE_PATH_API}/bankfeed/v2/bankaccounts/:bankGlAccountId/transactions/uncleared`
    },
    /*     New yodlee calls, found in bank-feed.d.ts */
    getAccessToken: {
        method: 'GET',
        url: `${BASE_PATH_API}/bankfeed/v2/accessToken`
    },
    getAccount: {
        method: 'GET',
        url: `${BASE_PATH_API}/bankfeed/v2/accounts/:externalAccountId`
    },
    getAccounts: {
        method: 'GET',
        url: `${BASE_PATH_API}/bankfeed/v2/accounts`
    },
    getBankFeedYodleeFastLinkConfigs: {
        method: 'GET',
        url: `${BASE_PATH_API}/bankfeed/v2/fastlinkconfigs`
    },
    getTransactions: {
        method: 'GET',
        url: `${BASE_PATH_API}/bankfeed/v2/transactions/:bankGlAccountId`
    },
    linkBankAccount: {
        method: 'POST',
        url: `${BASE_PATH_API}/bankfeed/v2/linkBankAccount`
    },
    getLinkedBankAccount: {
        method: 'GET',
        url: `${BASE_PATH_API}/bankfeed/v2/linkedBankAccount/:bankGlAccountId`
    },
    createTestBankFeedTransactionV2: {
        method: 'POST',
        url: `${BASE_PATH_API}/bankfeed/v2/transaction`
    },
    deleteTestBankFeedTransactionV2: {
        method: 'DELETE',
        url: `${BASE_PATH_API}/bankfeed/v2/transaction/:transactionId`
    },
    getTestBankFeedTransactions: {
        method: 'GET',
        url: `${BASE_PATH_API}/bankfeed/v2/transaction/test/:bankGlAccountId`
    },
    getBankFeedAccountV2: {
        method: 'GET',
        url: `${BASE_PATH_API}/bankfeed/v2/:bankGlAccountId/bankFeedAccount`
    },
    updateBankFeedAccountSettings: {
        method: 'PUT',
        url: `${BASE_PATH_API}/bankfeed/v2/bankFeedAccountSettings`
    },
    updateIgnoreTransactionStatus: {
        method: 'POST',
        url: `${BASE_PATH_API}/bankfeed/v2/transaction/:transactionId/ignoreStatus`
    },
    matchBankFeedTransaction: {
        method: 'POST',
        url: `${BASE_PATH_API}/bankfeed/v2/linkedBankAccount/:bankGlAccountId/match`
    },
    getClearedTransactionsV2: {
        method: 'GET',
        url: `${BASE_PATH_API}/bankfeed/v2/transactions/:bankGlAccountId/matches`
    },
    unMatchBankFeedTransaction: {
        method: 'POST',
        url: `${BASE_PATH_API}/bankfeed/v2/transaction/:transactionId/unmatch`
    },
    refreshBankFeedAccountV2: {
        method: 'POST',
        url: `${BASE_PATH_API}/bankfeed/v2/bankaccount/:id/refresh`
    },
    unlinkBankFeedAccount: {
        method: 'PUT',
        url: `${BASE_PATH_API}/bankfeed/v2/unlinkBankAccount/:bankFeedAccountGuid`
    },
    deleteYodleeAccountV2: {
        method: 'DELETE',
        url: `${BASE_PATH_API}/bankfeed/v2/linkedBankAccount/:bankGlAccountId`
    },
    scheduleMigrateDataBatchJob: {
        method: 'POST',
        url: `${BASE_PATH_API}/bankfeed/v2/scheduleMigrateDataBatchJob`
    },
    getTransactionCountRollup: {
        method: 'GET',
        url: `${BASE_PATH_API}/bankfeed/v2/transactions/rollup`,
        transformResponse: function transformResponse(response, headers) {
            const totalCount = headers.get('x-total-count');
            return totalCount === null
                ? null
                : {
                    Data: response,
                    TotalCount: totalCount
                };
        }
    }
};

export function BankFeedApi() {
    const service = createActions(actions);
    return service;
}
